import React from 'react';
import Category from '../../components/category';
import Layout from '../layout';

const CategoryContainer = () => (
  <Layout>
    <Category />
  </Layout>
);

export default CategoryContainer;
